import * as React from 'react';
import { forwardRef } from 'react';

import { InputFormGroupType, InputFormGroupProps, InputFormGroup } from '@admin/components/fields';

export const CityFormGroup = forwardRef<InputFormGroupType, InputFormGroupProps>((props, ref) => (
  <InputFormGroup type="text" id="address-city" label="City" ref={ref} {...props} />
));
